import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, vModelText as _vModelText, resolveDirective as _resolveDirective, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "notification-panel__content" }
const _hoisted_4 = { class: "form estate-setup-form" }
const _hoisted_5 = { class: "form-inline-group fg1" }
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = { class: "form-field multiple-inputs no-wrap checkboxes" }
const _hoisted_9 = {
  key: 0,
  class: "checkbox-switch"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_12 = { class: "check-label" }
const _hoisted_13 = {
  key: 1,
  class: "checkbox"
}
const _hoisted_14 = ["checked"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_16 = {
  key: 2,
  class: "checkbox"
}
const _hoisted_17 = ["checked"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "checkbox"
}
const _hoisted_20 = ["checked"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_22 = { class: "checkbox" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_25 = { class: "checkbox-switch" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_28 = { class: "check-label" }
const _hoisted_29 = { class: "width-wrap" }
const _hoisted_30 = { class: "content" }
const _hoisted_31 = ["href"]
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = {
  key: 0,
  class: "width-wrap"
}
const _hoisted_37 = { class: "page-content__header" }
const _hoisted_38 = { style: {"text-align":"center"} }
const _hoisted_39 = {
  key: 1,
  class: "form-messages"
}
const _hoisted_40 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_41 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_42 = { class: "estate-add" }
const _hoisted_43 = {
  key: 0,
  class: "width-wrap"
}
const _hoisted_44 = { class: "page-navbar" }
const _hoisted_45 = { class: "width-wrap" }
const _hoisted_46 = { class: "form-heading" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = { class: "form-field" }
const _hoisted_49 = { for: "frm-estateAddForm_estateFrontSubType" }
const _hoisted_50 = { class: "selectbox" }
const _hoisted_51 = ["label"]
const _hoisted_52 = ["value", "disabled"]
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = { for: "frm-estateAddForm_price" }
const _hoisted_55 = ["placeholder", "disabled"]
const _hoisted_56 = { class: "help" }
const _hoisted_57 = { class: "checkbox" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_59 = {
  key: 0,
  class: "form-error"
}
const _hoisted_60 = {
  key: 1,
  class: "form-error"
}
const _hoisted_61 = {
  key: 2,
  class: "form-error"
}
const _hoisted_62 = { for: "frm-estateAddForm_estateArea" }
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "help" }, [
  /*#__PURE__*/_createTextVNode(" v m "),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_65 = {
  key: 0,
  class: "form-error"
}
const _hoisted_66 = {
  key: 1,
  class: "form-error"
}
const _hoisted_67 = {
  key: 2,
  class: "form-error"
}
const _hoisted_68 = {
  key: 0,
  class: "form-group dynamic-fields"
}
const _hoisted_69 = { class: "form-field" }
const _hoisted_70 = { for: "frm-estateAddForm_area" }
const _hoisted_71 = { class: "multiple-inputs" }
const _hoisted_72 = ["placeholder"]
const _hoisted_73 = {
  class: "selectbox",
  style: {"max-width":"100px"}
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("option", { value: "a" }, "a", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("option", { value: "ha" }, "ha", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("option", { value: "m2" }, "m²", -1)
const _hoisted_77 = [
  _hoisted_74,
  _hoisted_75,
  _hoisted_76
]
const _hoisted_78 = { class: "calc" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_80 = {
  key: 0,
  class: "form-error"
}
const _hoisted_81 = {
  key: 1,
  class: "form-error"
}
const _hoisted_82 = {
  key: 2,
  class: "form-error"
}
const _hoisted_83 = {
  key: 0,
  class: "form-error"
}
const _hoisted_84 = { for: "frm-estateAddForm_usefulArea" }
const _hoisted_85 = ["placeholder"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "help" }, [
  /*#__PURE__*/_createTextVNode(" v m "),
  /*#__PURE__*/_createElementVNode("sup", null, "2")
], -1)
const _hoisted_87 = {
  key: 0,
  class: "form-error"
}
const _hoisted_88 = {
  key: 1,
  class: "form-error"
}
const _hoisted_89 = {
  key: 2,
  class: "form-error"
}
const _hoisted_90 = {
  key: 1,
  class: "form-field"
}
const _hoisted_91 = { for: "frm-estateAddForm_area" }
const _hoisted_92 = { class: "multiple-inputs" }
const _hoisted_93 = ["placeholder"]
const _hoisted_94 = {
  class: "selectbox",
  style: {"max-width":"100px"}
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("option", { value: "a" }, "a", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("option", { value: "ha" }, "ha", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("option", { value: "m2" }, "m²", -1)
const _hoisted_98 = [
  _hoisted_95,
  _hoisted_96,
  _hoisted_97
]
const _hoisted_99 = { class: "calc" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_101 = {
  key: 0,
  class: "form-error"
}
const _hoisted_102 = {
  key: 1,
  class: "form-error"
}
const _hoisted_103 = {
  key: 0,
  class: "form-error"
}
const _hoisted_104 = {
  key: 1,
  class: "form-group"
}
const _hoisted_105 = { for: "frm-estateAddForm_parkingPlaceCount" }
const _hoisted_106 = {
  key: 0,
  class: "form-error"
}
const _hoisted_107 = {
  key: 1,
  class: "form-error"
}
const _hoisted_108 = {
  key: 2,
  class: "form-group"
}
const _hoisted_109 = { for: "frm-estateAddForm_energyPrice" }
const _hoisted_110 = ["placeholder"]
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "help" }, "v EUR", -1)
const _hoisted_112 = {
  key: 0,
  class: "form-error"
}
const _hoisted_113 = {
  key: 1,
  class: "form-error"
}
const _hoisted_114 = { class: "form-group" }
const _hoisted_115 = { for: "frm-estateAddForm_bedCount" }
const _hoisted_116 = { class: "input-group" }
const _hoisted_117 = { class: "input-group-prepend" }
const _hoisted_118 = { class: "input-group-append" }
const _hoisted_119 = {
  key: 0,
  class: "form-error"
}
const _hoisted_120 = {
  key: 1,
  class: "form-error"
}
const _hoisted_121 = { for: "frm-estateAddForm_availableFrom" }
const _hoisted_122 = { class: "form-group" }
const _hoisted_123 = { for: "frm-estateAddForm_personCount" }
const _hoisted_124 = { class: "input-group" }
const _hoisted_125 = { class: "input-group-prepend" }
const _hoisted_126 = { class: "input-group-append" }
const _hoisted_127 = {
  key: 0,
  class: "form-error"
}
const _hoisted_128 = {
  key: 1,
  class: "form-error"
}
const _hoisted_129 = { for: "frm-estateAddForm_adSex" }
const _hoisted_130 = { class: "selectbox" }
const _hoisted_131 = { value: null }
const _hoisted_132 = ["value"]
const _hoisted_133 = {
  key: 0,
  class: "form-error"
}
const _hoisted_134 = { for: "frm-estateAddForm_adAge" }
const _hoisted_135 = { class: "selectbox" }
const _hoisted_136 = { value: null }
const _hoisted_137 = ["value"]
const _hoisted_138 = {
  key: 0,
  class: "form-error"
}
const _hoisted_139 = {
  key: 4,
  class: "form-group"
}
const _hoisted_140 = { for: "frm-estateAddForm_hasPetsAllowed" }
const _hoisted_141 = { class: "selectbox" }
const _hoisted_142 = { value: null }
const _hoisted_143 = { value: true }
const _hoisted_144 = { value: false }
const _hoisted_145 = {
  key: 0,
  class: "form-error"
}
const _hoisted_146 = { for: "frm-estateAddForm_hasSmokersAllowed" }
const _hoisted_147 = { class: "selectbox" }
const _hoisted_148 = { value: null }
const _hoisted_149 = { value: true }
const _hoisted_150 = { value: false }
const _hoisted_151 = {
  key: 0,
  class: "form-error"
}
const _hoisted_152 = { for: "frm-estateAddForm_title" }
const _hoisted_153 = ["placeholder"]
const _hoisted_154 = { class: "help" }
const _hoisted_155 = {
  key: 0,
  class: "form-error"
}
const _hoisted_156 = {
  key: 1,
  class: "form-error"
}
const _hoisted_157 = {
  key: 5,
  class: "form-field"
}
const _hoisted_158 = { for: "frm-estateAddForm_engineeringNetwork" }
const _hoisted_159 = { class: "checkboxlist grid-4" }
const _hoisted_160 = { class: "checkbox" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_162 = { class: "checkbox" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_164 = { class: "checkbox" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_166 = {
  key: 0,
  class: "checkbox"
}
const _hoisted_167 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_168 = { class: "form-group" }
const _hoisted_169 = { for: "frm-estateAddForm_status" }
const _hoisted_170 = { class: "selectbox" }
const _hoisted_171 = ["value"]
const _hoisted_172 = {
  key: 0,
  class: "form-error"
}
const _hoisted_173 = { for: "frm-estateAddForm_status" }
const _hoisted_174 = { class: "selectbox" }
const _hoisted_175 = { value: null }
const _hoisted_176 = ["value"]
const _hoisted_177 = {
  key: 0,
  class: "form-error"
}
const _hoisted_178 = { for: "frm-estateAddForm_floor" }
const _hoisted_179 = { class: "multiple-inputs" }
const _hoisted_180 = ["placeholder"]
const _hoisted_181 = /*#__PURE__*/_createElementVNode("span", { class: "text-separator" }, "z", -1)
const _hoisted_182 = ["placeholder", "disabled"]
const _hoisted_183 = {
  key: 0,
  class: "form-error"
}
const _hoisted_184 = {
  key: 1,
  class: "form-error"
}
const _hoisted_185 = { class: "form-field" }
const _hoisted_186 = { for: "frm-estateAddForm_otherProperties" }
const _hoisted_187 = { class: "checkboxlist grid-2" }
const _hoisted_188 = { class: "checkbox-wrap has-textinput" }
const _hoisted_189 = { class: "checkbox" }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_191 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_192 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v m²", -1)
const _hoisted_193 = { class: "checkbox-wrap has-textinput" }
const _hoisted_194 = { class: "checkbox" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_196 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_197 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v m²", -1)
const _hoisted_198 = { class: "checkbox-wrap has-textinput" }
const _hoisted_199 = { class: "checkbox" }
const _hoisted_200 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_201 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_202 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v m²", -1)
const _hoisted_203 = { class: "checkbox-wrap has-textinput" }
const _hoisted_204 = { class: "checkbox" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_206 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_207 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v ks", -1)
const _hoisted_208 = { class: "checkbox-wrap has-textinput" }
const _hoisted_209 = { class: "checkbox" }
const _hoisted_210 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_211 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_212 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v ks", -1)
const _hoisted_213 = { class: "checkbox-wrap has-textinput" }
const _hoisted_214 = { class: "checkbox" }
const _hoisted_215 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_216 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_217 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v ks", -1)
const _hoisted_218 = { class: "form-group" }
const _hoisted_219 = { for: "frm-estateAddForm_estateState" }
const _hoisted_220 = { class: "selectbox" }
const _hoisted_221 = { value: null }
const _hoisted_222 = ["value"]
const _hoisted_223 = {
  key: 0,
  class: "form-error"
}
const _hoisted_224 = { for: "frm-estateAddForm_roomCount" }
const _hoisted_225 = ["placeholder"]
const _hoisted_226 = {
  key: 0,
  class: "form-error"
}
const _hoisted_227 = {
  key: 1,
  class: "form-error"
}
const _hoisted_228 = { class: "form-field" }
const _hoisted_229 = { for: "frm-estateAddForm_otherProperties" }
const _hoisted_230 = { class: "checkboxlist grid-2" }
const _hoisted_231 = { class: "checkbox-wrap has-textinput" }
const _hoisted_232 = { class: "checkbox" }
const _hoisted_233 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_234 = {
  key: 0,
  class: "input-wrap has-hint"
}
const _hoisted_235 = /*#__PURE__*/_createElementVNode("span", { class: "hint" }, "v ks", -1)
const _hoisted_236 = { class: "checkbox" }
const _hoisted_237 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_238 = { for: "frm-estateAddForm_virtualTourLink" }
const _hoisted_239 = { for: "frm-estateAddForm_videoLink" }
const _hoisted_240 = { class: "section section--gray estate-add__gallery" }
const _hoisted_241 = { class: "width-wrap" }
const _hoisted_242 = { class: "form-heading" }
const _hoisted_243 = { key: 0 }
const _hoisted_244 = {
  class: "upload-placeholder",
  ref: "fileuploader"
}
const _hoisted_245 = { class: "thumb-image" }
const _hoisted_246 = ["src"]
const _hoisted_247 = {
  key: 2,
  class: "image-label"
}
const _hoisted_248 = {
  key: 3,
  class: "thumb-text"
}
const _hoisted_249 = ["onClick"]
const _hoisted_250 = { class: "section estate-add__info" }
const _hoisted_251 = { class: "width-wrap" }
const _hoisted_252 = { for: "frm-estateAddForm_description" }
const _hoisted_253 = ["placeholder"]
const _hoisted_254 = {
  key: 0,
  class: "form-error"
}
const _hoisted_255 = {
  key: 0,
  class: "width-wrap"
}
const _hoisted_256 = { for: "frm-estateAddForm_web" }
const _hoisted_257 = ["placeholder"]
const _hoisted_258 = { class: "width-wrap" }
const _hoisted_259 = { for: "frm-estateAddForm_country" }
const _hoisted_260 = { class: "width-wrap" }
const _hoisted_261 = {
  key: 0,
  class: "form-error"
}
const _hoisted_262 = {
  key: 1,
  class: "width-wrap"
}
const _hoisted_263 = { for: "frm-estateAddForm_estateAgent" }
const _hoisted_264 = { class: "selectbox" }
const _hoisted_265 = /*#__PURE__*/_createElementVNode("option", { value: null }, null, -1)
const _hoisted_266 = ["value"]
const _hoisted_267 = {
  key: 0,
  class: "section estate-add__register"
}
const _hoisted_268 = { class: "width-wrap" }
const _hoisted_269 = { class: "form-heading" }
const _hoisted_270 = { key: 0 }
const _hoisted_271 = { class: "form-group" }
const _hoisted_272 = { for: "frm-registerForm_userName" }
const _hoisted_273 = {
  key: 0,
  class: "form-error"
}
const _hoisted_274 = { for: "frm-registerForm_phoneNumber" }
const _hoisted_275 = { class: "multiple-inputs" }
const _hoisted_276 = { class: "selectbox selectbox--phone-prefix" }
const _hoisted_277 = {
  key: 0,
  class: "form-error"
}
const _hoisted_278 = { class: "form-group" }
const _hoisted_279 = { for: "frm-registerForm_email" }
const _hoisted_280 = {
  key: 0,
  class: "form-error"
}
const _hoisted_281 = {
  key: 1,
  class: "form-error"
}
const _hoisted_282 = { for: "frm-registerForm_confirmEmail" }
const _hoisted_283 = { class: "help" }
const _hoisted_284 = {
  key: 0,
  class: "form-error"
}
const _hoisted_285 = {
  key: 1,
  class: "form-error"
}
const _hoisted_286 = { class: "form-group" }
const _hoisted_287 = { for: "frm-registerForm_password" }
const _hoisted_288 = { class: "help" }
const _hoisted_289 = {
  key: 0,
  class: "form-error"
}
const _hoisted_290 = {
  key: 1,
  class: "form-error"
}
const _hoisted_291 = { for: "frm-registerForm_confirmPassword" }
const _hoisted_292 = { class: "help" }
const _hoisted_293 = {
  key: 0,
  class: "form-error"
}
const _hoisted_294 = {
  key: 1,
  class: "form-error"
}
const _hoisted_295 = { class: "checkbox" }
const _hoisted_296 = ["innerHTML"]
const _hoisted_297 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_298 = {
  key: 0,
  class: "form-error"
}
const _hoisted_299 = { class: "checkbox" }
const _hoisted_300 = ["innerHTML"]
const _hoisted_301 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_302 = {
  key: 0,
  class: "form-error"
}
const _hoisted_303 = { class: "checkbox" }
const _hoisted_304 = ["innerHTML"]
const _hoisted_305 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_306 = {
  key: 0,
  class: "form-error"
}
const _hoisted_307 = {
  key: 1,
  class: "section estate-add__footer"
}
const _hoisted_308 = { class: "width-wrap" }
const _hoisted_309 = { class: "button button--primary is-size-medium" }
const _hoisted_310 = {
  key: 1,
  class: "section section--reviews",
  id: "reviews"
}
const _hoisted_311 = { class: "notification-panel__content" }
const _hoisted_312 = { class: "form estate-setup-form" }
const _hoisted_313 = { class: "form-inline-group fg1" }
const _hoisted_314 = { class: "form-field" }
const _hoisted_315 = { class: "form-field" }
const _hoisted_316 = { class: "form-field multiple-inputs no-wrap checkboxes" }
const _hoisted_317 = {
  key: 0,
  class: "checkbox-switch"
}
const _hoisted_318 = ["disabled"]
const _hoisted_319 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_320 = { class: "check-label" }
const _hoisted_321 = {
  key: 1,
  class: "checkbox"
}
const _hoisted_322 = ["checked"]
const _hoisted_323 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_324 = {
  key: 2,
  class: "checkbox"
}
const _hoisted_325 = ["checked"]
const _hoisted_326 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_327 = {
  key: 0,
  class: "checkbox"
}
const _hoisted_328 = ["checked"]
const _hoisted_329 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_330 = { class: "checkbox" }
const _hoisted_331 = ["checked"]
const _hoisted_332 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_333 = { class: "checkbox-switch" }
const _hoisted_334 = ["disabled"]
const _hoisted_335 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_336 = { class: "check-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_FlashMessage = _resolveComponent("FlashMessage")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_SortableItem = _resolveComponent("SortableItem")!
  const _component_SortableList = _resolveComponent("SortableList")!
  const _component_MapPosition = _resolveComponent("MapPosition")!
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_PhonePrefix = _resolveComponent("PhonePrefix")!
  const _component_EstateAgentReviewRequestForm = _resolveComponent("EstateAgentReviewRequestForm")!
  const _component_FixedElement = _resolveComponent("FixedElement")!
  const _component_AdPreview = _resolveComponent("AdPreview")!
  const _directive_handle = _resolveDirective("handle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _createElementVNode("title", null, "\r\n      " + _toDisplayString(_ctx.isInsert ? _ctx.$t('AdForm.title-insert') : _ctx.$t('AdForm.title-edit')) + "\r\n    ", 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isEdit)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["notification-panel", _ctx.notificationClass]),
            ref: "topNotificationPanel"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["width-wrap", { 'disabled-all': _ctx.isLoading }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
                return (_openBlock(), _createBlock(_component_FlashMessage, {
                  key: index,
                  message: message
                }, {
                  default: _withCtx(() => [
                    (message.code == 'confirmemail')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!_ctx.isConfirmEmailSent)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "button button--warning reversed",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendConfirmEmail && _ctx.sendConfirmEmail(...args)))
                              }, _toDisplayString(_ctx.$t('AdForm.button-send-confirm-email')), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('AdForm.confirm-email-success', { email: _ctx.user.email })), 1))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["message"]))
              }), 128)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("form", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "button button--primary",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save(true)))
                      }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-save-short' : 'AdForm.button-save')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        class: "button button--primary reversed",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onShowPreview && _ctx.onShowPreview(...args)))
                      }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-preview-short' : 'AdForm.button-preview')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_multiselect, {
                            key: 0,
                            class: "multiselect-statuses w200",
                            modelValue: _ctx.publishStatus,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.publishStatus) = $event)),
                            options: _ctx.publishStatuses,
                            "show-labels": false,
                            searchable: false,
                            "allow-empty": false
                          }, {
                            singleLabel: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.status-change')), 1)
                            ]),
                            option: _withCtx(({ option }) => [
                              (option === 'publish')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isPublished) = $event)),
                                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                      disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                                    }, null, 40, _hoisted_10), [
                                      [_vModelCheckbox, _ctx.isPublished]
                                    ]),
                                    _hoisted_11,
                                    _createElementVNode("span", _hoisted_12, [
                                      (_ctx.form.isPublished)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('AdForm.published')), 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('AdForm.unpublished')), 1)
                                          ], 64))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (option === 'reserve' && !_ctx.isDeveloperProjectEstate)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.reserved')), 1),
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: _ctx.form.isReserved,
                                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onReservedChanged && _ctx.onReservedChanged(...args)))
                                    }, null, 40, _hoisted_14),
                                    _hoisted_15
                                  ]))
                                : _createCommentVNode("", true),
                              (option === 'archive')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_16, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.archived')), 1),
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: _ctx.form.isArchived,
                                      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                    }, null, 40, _hoisted_17),
                                    _hoisted_18
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!_ctx.isDeveloperProjectEstate)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_19, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.reserved')), 1),
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    checked: _ctx.form.isReserved,
                                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onReservedChanged && _ctx.onReservedChanged(...args)))
                                  }, null, 40, _hoisted_20),
                                  _hoisted_21
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("label", _hoisted_22, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.archived')), 1),
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.form.isArchived,
                                onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                              }, null, 40, _hoisted_23),
                              _hoisted_24
                            ]),
                            _createElementVNode("label", _hoisted_25, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isPublished) = $event)),
                                onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                              }, null, 40, _hoisted_26), [
                                [_vModelCheckbox, _ctx.isPublished]
                              ]),
                              _hoisted_27,
                              _createElementVNode("span", _hoisted_28, [
                                (_ctx.form.isPublished)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('AdForm.published')), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('AdForm.unpublished')), 1)
                                    ], 64))
                              ])
                            ])
                          ], 64))
                    ])
                  ])
                ])
              ])
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "page-header",
        style: _normalizeStyle(_ctx.isCompetition ? 'text-align: center' : '')
      }, [
        _createElementVNode("div", _hoisted_29, [
          (_ctx.isCompetition)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_router_link, {
                    to: { name: 'AdSearch' },
                    custom: ""
                  }, {
                    default: _withCtx(({ href }) => [
                      _createElementVNode("a", {
                        href: href,
                        id: "header-logo",
                        style: {"display":"inline-block"}
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.logoUrl,
                          width: "270",
                          height: "47",
                          alt: _ctx.domain + ' logo'
                        }, null, 8, _hoisted_32)
                      ], 8, _hoisted_31)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("h1", {
                    innerHTML: _ctx.$t('AdForm.competition-header')
                  }, null, 8, _hoisted_33)
                ]),
                _createVNode(_component_ResizableImage, {
                  url: "/img/monitor-dell-win.webp",
                  width: 1104,
                  height: 743,
                  alt: "Monitor Dell win"
                })
              ], 64))
            : (_ctx.isInsert)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.$t('AdForm.title-insert')), 1),
                  (_ctx.isLoggedIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createTextVNode(_toDisplayString(_ctx.$t('AdForm.logged-in-as')) + " ", 1),
                        _createVNode(_component_router_link, { to: { name: 'UserProfile' } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.user.userName), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_ctx.isEdit)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_35, _toDisplayString(_ctx.$t('AdForm.title-edit')), 1))
                : _createCommentVNode("", true)
        ])
      ], 4),
      _createElementVNode("div", {
        class: _normalizeClass(["page-content", { 'pb-0': _ctx.isEdit }])
      }, [
        (_ctx.isCompetition)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("h2", _hoisted_38, _toDisplayString(_ctx.$t('AdForm.competition-draw')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFormMessages)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              (_ctx.isSuccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.$t('AdForm.success-message')), 1))
                : _createCommentVNode("", true),
              (_ctx.isError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flashmessage flash-danger"
                }, _toDisplayString(error), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_42, [
          (_ctx.isInsert)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("nav", _hoisted_44, [
                  _createElementVNode("ul", {
                    class: _normalizeClass(["nav-tabs", { 'is-centered': _ctx.isCompetition }])
                  }, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["adtype-1", { 'is-active': _ctx.isSale }])
                    }, [
                      _createElementVNode("a", {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.adTypeClick(1)))
                      }, _toDisplayString(_ctx.$t('AdForm.adtype-sale')), 1)
                    ], 2),
                    _createElementVNode("li", {
                      class: _normalizeClass(["adtype-2", { 'is-active': _ctx.isLease }])
                    }, [
                      _createElementVNode("a", {
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.adTypeClick(2)))
                      }, _toDisplayString(_ctx.$t('AdForm.adtype-lease')), 1)
                    ], 2),
                    (!_ctx.isLand)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: _normalizeClass(["adtype-3", { 'is-active': _ctx.isRoommate }])
                        }, [
                          _createElementVNode("a", {
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.adTypeClick(3)))
                          }, _toDisplayString(_ctx.$t('AdForm.adtype-roommate')), 1)
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            class: _normalizeClass(["form", { 'disabled-all': _ctx.isLoading }]),
            onSubmit: _cache[85] || (_cache[85] = _withModifiers(($event: any) => (_ctx.save(true)), ["prevent"])),
            autocomplete: "off"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["section estate-add__parameters", { 'pt-0': _ctx.isEdit }])
            }, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('AdForm.form-header')), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t(_ctx.isDeveloperProjectEstate ? 'AdForm.developer-project.estateFrontSubType' : 'AdForm.estateFrontSubType')) + ":", 1),
                    _createElementVNode("div", _hoisted_50, [
                      _withDirectives(_createElementVNode("select", {
                        id: "frm-estateAddForm_estateFrontSubType",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.form.estateFrontSubType.$model) = $event)),
                        name: "estateFrontSubType",
                        class: "form-control is-required"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estateTypes, (estateType) => {
                          return (_openBlock(), _createElementBlock("optgroup", {
                            label: estateType.value,
                            key: estateType.key
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(estateType.estateSubTypes, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.key,
                                key: item.key,
                                disabled: _ctx.isEstateTypeDisabled(item)
                              }, _toDisplayString(item.value), 9, _hoisted_52))
                            }), 128))
                          ], 8, _hoisted_51))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.v$.form.estateFrontSubType.$model]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.price.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_54, [
                      (_ctx.isSale)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdForm.price-sale')) + ":", 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.isLease)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdForm.price-lease')) + ":", 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.isRoommate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdForm.price-roommate')) + ":", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.v$.form.price.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_price",
                      placeholder: _ctx.pricePlaceholder,
                      disabled: _ctx.form.hasEmptyPrice,
                      name: "price",
                      class: "form-control is-required"
                    }, null, 8, _hoisted_55), [
                      [
                        _vModelText,
                        _ctx.v$.form.price.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('AdForm.price-help')), 1),
                    _createElementVNode("label", _hoisted_57, [
                      _createTextVNode(_toDisplayString(_ctx.$t(_ctx.user && _ctx.user.isEstateAgent ? 'AdForm.hasEmptyPriceAgent' : 'AdForm.hasEmptyPrice')) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "frm-estateAddForm_emptyPrice",
                        name: "hasEmptyPrice",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.v$.form.hasEmptyPrice.$model) = $event)),
                        onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onEmptyPriceChange && _ctx.onEmptyPriceChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.v$.form.hasEmptyPrice.$model]
                      ]),
                      _hoisted_58
                    ]),
                    (_ctx.v$.form.price.$dirty && _ctx.v$.form.price.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.price.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.price.integer.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t('forms.integer')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.price.minValue.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t('forms.minValue', { value: _ctx.v$.form.price.minValue.$params.min })), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  (!_ctx.isLand)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.estateArea.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_62, [
                          (_ctx.isRoommate)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('AdForm.estateArea-roommate')) + ":", 1)
                              ], 64))
                            : (_ctx.isHouse)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('AdForm.estateArea-house')) + ":", 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.isDeveloperProjectEstate ? 'AdForm.developer-project.estateArea' : 'AdForm.estateArea')) + ":", 1)
                                ], 64))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.v$.form.estateArea.$model) = $event)),
                          type: "text",
                          id: "frm-estateAddForm_estateArea",
                          placeholder: _ctx.$t('AdForm.estateArea-placeholder'),
                          name: "estateArea",
                          class: "form-control is-required"
                        }, null, 8, _hoisted_63), [
                          [
                            _vModelText,
                            _ctx.v$.form.estateArea.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _hoisted_64,
                        (_ctx.v$.form.estateArea.$dirty && _ctx.v$.form.estateArea.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.estateArea.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.estateArea.decimal.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.estateArea.minValue.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.$t('forms.minValueExclude', { value: 0 })), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isHouse || _ctx.isLand)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('AdForm.landArea')) + ":", 1),
                        _createElementVNode("div", _hoisted_71, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "frm-estateAddForm_landArea",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.v$.form.landArea.$model) = $event)),
                            style: {"max-width":"125px"},
                            placeholder: _ctx.$t('AdForm.example') + _ctx.defaultArea,
                            class: "form-control is-required"
                          }, null, 8, _hoisted_72), [
                            [_vModelText, _ctx.v$.form.landArea.$model]
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _withDirectives(_createElementVNode("select", {
                              id: "frm-estateAddForm_areaUnit",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.v$.form.landAreaUnit.$model) = $event)),
                              name: "type",
                              class: "form-control is-required"
                            }, _hoisted_77, 512), [
                              [_vModelSelect, _ctx.v$.form.landAreaUnit.$model]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _createTextVNode(_toDisplayString(_ctx.landArea) + " m ", 1),
                            _hoisted_79
                          ])
                        ]),
                        (_ctx.v$.form.landArea.$dirty && _ctx.v$.form.landArea.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.landArea.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.landArea.decimal.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.landArea.minValue.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_ctx.$t('forms.minValue', { value: _ctx.v$.form.landArea.minValue.$params.min })), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.landAreaUnit.$dirty && _ctx.v$.form.landAreaUnit.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.v$.form.landAreaUnit.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.isHouse)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.usefulArea.$error }])
                          }, [
                            _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t('AdForm.usefulArea')) + ":", 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.v$.form.usefulArea.$model) = $event)),
                              type: "text",
                              id: "frm-estateAddForm_usefulArea",
                              placeholder: _ctx.$t('AdForm.example') + '80',
                              name: "usefulArea",
                              class: "form-control is-required"
                            }, null, 8, _hoisted_85), [
                              [
                                _vModelText,
                                _ctx.v$.form.usefulArea.$model,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            _hoisted_86,
                            (_ctx.v$.form.usefulArea.$dirty && _ctx.v$.form.usefulArea.$invalid)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.v$.form.usefulArea.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString(_ctx.$t('forms.required')), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.v$.form.usefulArea.decimal.$invalid)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.v$.form.usefulArea.minValue.$invalid)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(_ctx.$t('forms.minValue', { value: _ctx.v$.form.usefulArea.minValue.$params.min })), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 2))
                        : _createCommentVNode("", true),
                      (_ctx.isLand)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                            _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t('AdForm.builtUpArea')) + ":", 1),
                            _createElementVNode("div", _hoisted_92, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                id: "frm-estateAddForm_builtUpArea",
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.v$.form.builtUpArea.$model) = $event)),
                                style: {"max-width":"125px"},
                                placeholder: _ctx.$t('AdForm.example') + _ctx.defaultArea,
                                class: "form-control"
                              }, null, 8, _hoisted_93), [
                                [_vModelText, _ctx.v$.form.builtUpArea.$model]
                              ]),
                              _createElementVNode("div", _hoisted_94, [
                                _withDirectives(_createElementVNode("select", {
                                  id: "frm-estateAddForm_builtUpAreaUnit",
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.v$.form.builtUpAreaUnit.$model) = $event)),
                                  name: "type",
                                  class: "form-control"
                                }, _hoisted_98, 512), [
                                  [_vModelSelect, _ctx.v$.form.builtUpAreaUnit.$model]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_99, [
                                _createTextVNode(_toDisplayString(_ctx.builtUpArea) + " m ", 1),
                                _hoisted_100
                              ])
                            ]),
                            (_ctx.v$.form.builtUpArea.$dirty && _ctx.v$.form.builtUpArea.$invalid)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.v$.form.builtUpArea.decimal.$invalid)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.v$.form.builtUpArea.minValue.$invalid)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_ctx.$t('forms.minValue', { value: _ctx.v$.form.builtUpArea.minValue.$params.min })), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.v$.form.builtUpAreaUnit.$dirty && _ctx.v$.form.builtUpAreaUnit.$invalid)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.v$.form.builtUpAreaUnit.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(_ctx.$t('forms.required')), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isParkingSpace)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.parkingPlaceCount.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t('AdForm.parkingPlaceCount')) + ":", 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "frm-estateAddForm_parkingPlaceCount",
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.v$.form.parkingPlaceCount.$model) = $event)),
                          name: "parkingPlaceCount",
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.v$.form.parkingPlaceCount.$model]
                        ]),
                        (_ctx.v$.form.parkingPlaceCount.$dirty && _ctx.v$.form.parkingPlaceCount.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.parkingPlaceCount.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.parkingPlaceCount.decimal.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isLease)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.energyPrice.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t('AdForm.energyPrice')) + ": ", 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.v$.form.energyPrice.$model) = $event)),
                          type: "text",
                          id: "frm-registerForm_energyPrice",
                          placeholder: _ctx.$t('AdForm.energyPrice-placeholder'),
                          name: "energyPrice",
                          class: "form-control"
                        }, null, 8, _hoisted_110), [
                          [
                            _vModelText,
                            _ctx.v$.form.energyPrice.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _hoisted_111,
                        (_ctx.v$.form.energyPrice.$dirty && _ctx.v$.form.energyPrice.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.energyPrice.decimal.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.energyPrice.minValue.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(_ctx.$t('forms.minValue', { value: _ctx.v$.form.energyPrice.minValue.$params.min })), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isRoommate)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.bedCount.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t('AdForm.bedCount')) + ":", 1),
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "button",
                                onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.subtractBedCount && _ctx.subtractBedCount(...args)))
                              }, "-")
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "frm-estateAddForm_bedCount",
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.v$.form.bedCount.$model) = $event)),
                              name: "bedCount",
                              class: "form-control is-required"
                            }, null, 512), [
                              [_vModelText, _ctx.v$.form.bedCount.$model]
                            ]),
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "button",
                                onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.addBedCount && _ctx.addBedCount(...args)))
                              }, "+")
                            ])
                          ]),
                          (_ctx.v$.form.bedCount.$dirty && _ctx.v$.form.bedCount.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.bedCount.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_119, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.v$.form.bedCount.decimal.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_120, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.availableFrom.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.$t('AdForm.availableFrom')) + ":", 1),
                          _createVNode(_component_date_picker, {
                            id: "frm-estateAddForm_availableFrom",
                            placeholder: "Ihneď",
                            "input-class": "form-control",
                            name: "availableFrom",
                            lang: "sk",
                            "disabled-date": _ctx.notBeforeToday,
                            modelValue: _ctx.v$.form.availableFrom.$model,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.v$.form.availableFrom.$model) = $event)),
                            format: "DD.MM.YYYY",
                            "value-type": "format",
                            type: "date"
                          }, null, 8, ["disabled-date", "modelValue"])
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_122, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.personCount.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.$t('AdForm.personCount')) + ":", 1),
                          _createElementVNode("div", _hoisted_124, [
                            _createElementVNode("div", _hoisted_125, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "button",
                                onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.subtractPersonCount && _ctx.subtractPersonCount(...args)))
                              }, "-")
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              id: "frm-estateAddForm_personCount",
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.v$.form.personCount.$model) = $event)),
                              name: "personCount",
                              class: "form-control is-required"
                            }, null, 512), [
                              [_vModelText, _ctx.v$.form.personCount.$model]
                            ]),
                            _createElementVNode("div", _hoisted_126, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "button",
                                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.addPersonCount && _ctx.addPersonCount(...args)))
                              }, "+")
                            ])
                          ]),
                          (_ctx.v$.form.personCount.$dirty && _ctx.v$.form.personCount.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.personCount.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.v$.form.personCount.decimal.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_128, _toDisplayString(_ctx.$t('forms.decimal')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.adSex.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.$t('AdForm.sex')) + ":", 1),
                          _createElementVNode("div", _hoisted_130, [
                            _withDirectives(_createElementVNode("select", {
                              id: "frm-estateAddForm_adSex",
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.v$.form.adSex.$model) = $event)),
                              name: "adSex",
                              class: "form-control is-required"
                            }, [
                              _createElementVNode("option", _hoisted_131, _toDisplayString(_ctx.$t('AdForm.sex-empty-option')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adSexes, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key,
                                  key: item.key
                                }, _toDisplayString(item.value), 9, _hoisted_132))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.v$.form.adSex.$model]
                            ])
                          ]),
                          (_ctx.v$.form.adSex.$dirty && _ctx.v$.form.adSex.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.adSex.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_133, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.adAge.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.$t('AdForm.age')) + ":", 1),
                          _createElementVNode("div", _hoisted_135, [
                            _withDirectives(_createElementVNode("select", {
                              id: "frm-estateAddForm_adAge",
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.v$.form.adAge.$model) = $event)),
                              name: "adAge",
                              class: "form-control is-required"
                            }, [
                              _createElementVNode("option", _hoisted_136, _toDisplayString(_ctx.$t('AdForm.age-empty-option')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adAges, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key,
                                  key: item.key
                                }, _toDisplayString(item.value), 9, _hoisted_137))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.v$.form.adAge.$model]
                            ])
                          ]),
                          (_ctx.v$.form.adAge.$dirty && _ctx.v$.form.adAge.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.adAge.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_138, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                ((_ctx.isFlat || _ctx.isHouse || _ctx.isLand) && (_ctx.isLease || _ctx.isRoommate))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.hasPetsAllowed.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.$t('AdForm.hasPetsAllowed')) + ":", 1),
                        _createElementVNode("div", _hoisted_141, [
                          _withDirectives(_createElementVNode("select", {
                            id: "frm-estateAddForm_hasPetsAllowed",
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.v$.form.hasPetsAllowed.$model) = $event)),
                            name: "hasPetsAllowed",
                            class: "form-control"
                          }, [
                            _createElementVNode("option", _hoisted_142, _toDisplayString(_ctx.$t('AdForm.suitable-empty-option')), 1),
                            _createElementVNode("option", _hoisted_143, _toDisplayString(_ctx.$t('AdForm.suitable-yes')), 1),
                            _createElementVNode("option", _hoisted_144, _toDisplayString(_ctx.$t('AdForm.suitable-no')), 1)
                          ], 512), [
                            [_vModelSelect, _ctx.v$.form.hasPetsAllowed.$model]
                          ])
                        ]),
                        (_ctx.v$.form.hasPetsAllowed.$dirty && _ctx.v$.form.hasPetsAllowed.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.hasPetsAllowed.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_145, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.hasSmokersAllowed.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_146, _toDisplayString(_ctx.$t('AdForm.hasSmokersAllowed')) + ":", 1),
                        _createElementVNode("div", _hoisted_147, [
                          _withDirectives(_createElementVNode("select", {
                            id: "frm-estateAddForm_hasSmokersAllowed",
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.v$.form.hasSmokersAllowed.$model) = $event)),
                            name: "hasSmokersAllowed",
                            class: "form-control"
                          }, [
                            _createElementVNode("option", _hoisted_148, _toDisplayString(_ctx.$t('AdForm.suitable-empty-option')), 1),
                            _createElementVNode("option", _hoisted_149, _toDisplayString(_ctx.$t('AdForm.suitable-yes')), 1),
                            _createElementVNode("option", _hoisted_150, _toDisplayString(_ctx.$t('AdForm.suitable-no')), 1)
                          ], 512), [
                            [_vModelSelect, _ctx.v$.form.hasSmokersAllowed.$model]
                          ])
                        ]),
                        (_ctx.v$.form.hasSmokersAllowed.$dirty && _ctx.v$.form.hasSmokersAllowed.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.hasSmokersAllowed.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_151, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.title.$error }])
                }, [
                  _createElementVNode("label", _hoisted_152, _toDisplayString(_ctx.$t('AdForm.developer-project.title')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.v$.form.title.$model) = $event)),
                    type: "text",
                    id: "frm-estateAddForm_title",
                    placeholder: _ctx.$t('AdForm.developer-project.title-placeholder'),
                    name: "title",
                    class: "form-control is-required"
                  }, null, 8, _hoisted_153), [
                    [
                      _vModelText,
                      _ctx.v$.form.title.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_154, _toDisplayString(_ctx.$t('AdForm.title-help', { currentCount: _ctx.form.title ? _ctx.form.title.length : 0, maxCount: _ctx.v$.form.title.maxLength.$params.max })), 1),
                  (_ctx.v$.form.title.$dirty && _ctx.v$.form.title.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.title.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_155, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.title.maxLength.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_156, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.title.maxLength.$params.max })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                (_ctx.isLand || _ctx.isParkingSpace)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                      _createElementVNode("label", _hoisted_158, _toDisplayString(_ctx.$t('AdForm.networks')) + ":", 1),
                      _createElementVNode("div", _hoisted_159, [
                        _createElementVNode("label", _hoisted_160, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasWaterNetwork')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "frm-registerForm_water",
                            name: "water",
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.v$.form.hasWaterNetwork.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.v$.form.hasWaterNetwork.$model]
                          ]),
                          _hoisted_161
                        ]),
                        _createElementVNode("label", _hoisted_162, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasGasNetwork')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "frm-registerForm_gas",
                            name: "gas",
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.v$.form.hasGasNetwork.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.v$.form.hasGasNetwork.$model]
                          ]),
                          _hoisted_163
                        ]),
                        _createElementVNode("label", _hoisted_164, [
                          _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasElectricityNetwork')) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "frm-registerForm_electricity",
                            name: "electricity",
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.v$.form.hasElectricityNetwork.$model) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.v$.form.hasElectricityNetwork.$model]
                          ]),
                          _hoisted_165
                        ]),
                        (_ctx.isLand)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_166, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasCanalizationNetwork')) + " ", 1),
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "frm-registerForm_canalization",
                                name: "canalization",
                                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.v$.form.hasCanalizationNetwork.$model) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.v$.form.hasCanalizationNetwork.$model]
                              ]),
                              _hoisted_167
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isFlat)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createElementVNode("div", _hoisted_168, [
                        (_ctx.isDeveloperProjectEstate)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.developerProjectStatus.$error }])
                            }, [
                              _createElementVNode("label", _hoisted_169, _toDisplayString(_ctx.$t('AdForm.status')) + ":", 1),
                              _createElementVNode("div", _hoisted_170, [
                                _withDirectives(_createElementVNode("select", {
                                  id: "frm-estateAddForm_status",
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.v$.form.developerProjectStatus.$model) = $event)),
                                  name: "developerProjectStatus",
                                  class: "form-control"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.developerProjectStatuses, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key,
                                      key: item.key
                                    }, _toDisplayString(item.value), 9, _hoisted_171))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.v$.form.developerProjectStatus.$model]
                                ])
                              ]),
                              (_ctx.v$.form.developerProjectStatus.$dirty && _ctx.v$.form.developerProjectStatus.$invalid)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.v$.form.developerProjectStatus.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_172, _toDisplayString(_ctx.$t('forms.required')), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.status.$error }])
                            }, [
                              _createElementVNode("label", _hoisted_173, _toDisplayString(_ctx.$t('AdForm.status')) + ":", 1),
                              _createElementVNode("div", _hoisted_174, [
                                _withDirectives(_createElementVNode("select", {
                                  id: "frm-estateAddForm_status",
                                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.v$.form.status.$model) = $event)),
                                  name: "status",
                                  class: "form-control"
                                }, [
                                  _createElementVNode("option", _hoisted_175, _toDisplayString(_ctx.$t('AdForm.status-empty-option')), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.key,
                                      key: item.key
                                    }, _toDisplayString(item.value), 9, _hoisted_176))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _ctx.v$.form.status.$model]
                                ])
                              ]),
                              (_ctx.v$.form.status.$dirty && _ctx.v$.form.status.$invalid)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.v$.form.status.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_177, _toDisplayString(_ctx.$t('forms.required')), 1))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 2)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.floor.$error || _ctx.v$.form.maxFloor.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_178, _toDisplayString(_ctx.$t('AdForm.floor')) + ":", 1),
                          _createElementVNode("div", _hoisted_179, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              id: "frm-estateAddForm_floor",
                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.v$.form.floor.$model) = $event)),
                              name: "floor",
                              placeholder: _ctx.$t('AdForm.example') + '3',
                              class: "form-control",
                              onChange: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.onFloorChanged && _ctx.onFloorChanged(...args)))
                            }, null, 40, _hoisted_180), [
                              [_vModelText, _ctx.v$.form.floor.$model]
                            ]),
                            _hoisted_181,
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              id: "frm-estateAddForm_maxFloor",
                              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.v$.form.maxFloor.$model) = $event)),
                              name: "maxFloor",
                              placeholder: _ctx.$t('AdForm.example') + '6',
                              class: "form-control",
                              disabled: _ctx.isDeveloperProjectEstate,
                              onChange: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.onMaxFloorChanged && _ctx.onMaxFloorChanged(...args)))
                            }, null, 40, _hoisted_182), [
                              [_vModelText, _ctx.v$.form.maxFloor.$model]
                            ])
                          ]),
                          ((_ctx.v$.form.floor.$dirty && _ctx.v$.form.floor.$invalid) || (_ctx.v$.form.maxFloor.$dirty && _ctx.v$.form.maxFloor.$invalid))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.floor.required.$invalid || _ctx.v$.form.maxFloor.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_183, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.v$.form.floor.integer.$invalid || _ctx.v$.form.maxFloor.integer.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_184, _toDisplayString(_ctx.$t('forms.integer')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_185, [
                        _createElementVNode("label", _hoisted_186, _toDisplayString(_ctx.$t('AdForm.otherProperties')) + ":", 1),
                        _createElementVNode("div", _hoisted_187, [
                          _createElementVNode("div", _hoisted_188, [
                            _createElementVNode("label", _hoisted_189, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasBalcony')) + " ", 1),
                              _withDirectives(_createElementVNode("input", {
                                name: "frm-registerForm-balcony",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.hasBalcony) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.hasBalcony]
                              ]),
                              _hoisted_190
                            ]),
                            (_ctx.hasBalcony)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "frm-registerForm-balconyArea",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.v$.form.balconyArea.$model) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.v$.form.balconyArea.$model]
                                  ]),
                                  _hoisted_192
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_193, [
                            _createElementVNode("label", _hoisted_194, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasLoggia')) + " ", 1),
                              _withDirectives(_createElementVNode("input", {
                                name: "frm-registerForm-loggia",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.hasLoggia) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.hasLoggia]
                              ]),
                              _hoisted_195
                            ]),
                            (_ctx.hasLoggia)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "frm-registerForm-loggiaArea",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.v$.form.loggiaArea.$model) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.v$.form.loggiaArea.$model]
                                  ]),
                                  _hoisted_197
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_198, [
                            _createElementVNode("label", _hoisted_199, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasTerrace')) + " ", 1),
                              _withDirectives(_createElementVNode("input", {
                                name: "frm-registerForm-terrace",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.hasTerrace) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.hasTerrace]
                              ]),
                              _hoisted_200
                            ]),
                            (_ctx.hasTerrace)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "frm-registerForm-terraceArea",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.v$.form.terraceArea.$model) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.v$.form.terraceArea.$model]
                                  ]),
                                  _hoisted_202
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_203, [
                            _createElementVNode("label", _hoisted_204, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasLift')) + " ", 1),
                              _withDirectives(_createElementVNode("input", {
                                name: "frm-registerForm_hasLift",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.hasLift) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.hasLift]
                              ]),
                              _hoisted_205
                            ]),
                            (_ctx.hasLift)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "frm-registerForm_liftCount",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.v$.form.liftCount.$model) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.v$.form.liftCount.$model]
                                  ]),
                                  _hoisted_207
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_208, [
                            _createElementVNode("label", _hoisted_209, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasCellar')) + " ", 1),
                              _withDirectives(_createElementVNode("input", {
                                name: "frm-registerForm_hasCellar",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.hasCellar) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.hasCellar]
                              ]),
                              _hoisted_210
                            ]),
                            (_ctx.hasCellar)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "frm-registerForm_cellarCount",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.v$.form.cellarCount.$model) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.v$.form.cellarCount.$model]
                                  ]),
                                  _hoisted_212
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_213, [
                            _createElementVNode("label", _hoisted_214, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasParking')) + " ", 1),
                              _withDirectives(_createElementVNode("input", {
                                name: "frm-registerForm_parking",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.hasParking) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.hasParking]
                              ]),
                              _hoisted_215
                            ]),
                            (_ctx.hasParking)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "frm-registerForm_parkingPlaceCount",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.v$.form.parkingPlaceCount.$model) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.v$.form.parkingPlaceCount.$model]
                                  ]),
                                  _hoisted_217
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isHouse)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _createElementVNode("div", _hoisted_218, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.status.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_219, _toDisplayString(_ctx.$t('AdForm.status')) + ":", 1),
                          _createElementVNode("div", _hoisted_220, [
                            _withDirectives(_createElementVNode("select", {
                              id: "frm-estateAddForm_status",
                              "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.v$.form.status.$model) = $event)),
                              name: "status",
                              class: "form-control"
                            }, [
                              _createElementVNode("option", _hoisted_221, _toDisplayString(_ctx.$t('AdForm.status-empty-option')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.key,
                                  key: item.key
                                }, _toDisplayString(item.value), 9, _hoisted_222))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.v$.form.status.$model]
                            ])
                          ]),
                          (_ctx.v$.form.status.$dirty && _ctx.v$.form.status.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.status.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_223, _toDisplayString(_ctx.$t('forms.required')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.roomCount.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_224, _toDisplayString(_ctx.$t('AdForm.roomCount')) + ":", 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.v$.form.roomCount.$model) = $event)),
                          type: "text",
                          id: "frm-estateAddForm_roomCount",
                          name: "roomCount",
                          class: "form-control",
                          placeholder: _ctx.$t('AdForm.roomCount-placeholder')
                        }, null, 8, _hoisted_225), [
                          [
                            _vModelText,
                            _ctx.v$.form.roomCount.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.form.roomCount.$dirty && _ctx.v$.form.roomCount.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.roomCount.integer.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_226, _toDisplayString(_ctx.$t('forms.integer')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.roomCount.minValue.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_227, _toDisplayString(_ctx.$t('forms.minValue', { value: _ctx.v$.form.roomCount.minValue.$params.min })), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", _hoisted_228, [
                        _createElementVNode("label", _hoisted_229, _toDisplayString(_ctx.$t('AdForm.otherProperties')) + ":", 1),
                        _createElementVNode("div", _hoisted_230, [
                          _createElementVNode("div", _hoisted_231, [
                            _createElementVNode("label", _hoisted_232, [
                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasGarage')) + " ", 1),
                              _withDirectives(_createElementVNode("input", {
                                name: "frm-registerForm_hasGarage",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.hasGarage) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.hasGarage]
                              ]),
                              _hoisted_233
                            ]),
                            (_ctx.hasGarage)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_234, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "frm-registerForm_garageCount",
                                    class: "form-control",
                                    "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.v$.form.garageCount.$model) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.v$.form.garageCount.$model]
                                  ]),
                                  _hoisted_235
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("label", _hoisted_236, [
                            _createTextVNode(_toDisplayString(_ctx.$t('AdForm.hasCellar-house')) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              name: "frm-registerForm-cellar",
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.v$.form.hasCellar.$model) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.v$.form.hasCellar.$model]
                            ]),
                            _hoisted_237
                          ])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.virtualTourLink.$error }])
                }, [
                  _createElementVNode("label", _hoisted_238, _toDisplayString(_ctx.$t('AdForm.virtualTourLink')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.v$.form.virtualTourLink.$model) = $event)),
                    type: "text",
                    id: "frm-estateAddForm_virtualTourLink",
                    name: "virtualTourLink",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.virtualTourLink.$model,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.videoLink.$error }])
                }, [
                  _createElementVNode("label", _hoisted_239, _toDisplayString(_ctx.$t('AdForm.videoLink')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.v$.form.videoLink.$model) = $event)),
                    type: "text",
                    id: "frm-estateAddForm_videoLink",
                    name: "videoLink",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.videoLink.$model,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ], 2)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_240, [
              _createElementVNode("div", _hoisted_241, [
                _createElementVNode("div", _hoisted_242, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('AdForm.images')), 1),
                  (_ctx.dragAndDropCapable)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_243, [
                        _createElementVNode("em", null, _toDisplayString(_ctx.$t('AdForm.image-drag-n-drop')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_SortableList, {
                  list: _ctx.form.files,
                  "onUpdate:list": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.form.files) = $event)),
                  axis: "xy",
                  class: _normalizeClass(["form-gallery", { 'disabled-all': _ctx.isUploading }]),
                  helperClass: "thumb-drag",
                  useDragHandle: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SortableItem, {
                      disabled: true,
                      index: -1,
                      class: "thumb"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("label", _hoisted_244, [
                          _createElementVNode("input", {
                            type: "file",
                            id: "file",
                            ref: "files",
                            multiple: "",
                            onChange: _cache[68] || (_cache[68] = ($event: any) => (_ctx.handleFilesUpload())),
                            accept: "image/bmp, image/gif, image/jpeg, image/png"
                          }, null, 544),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.button-image-upload')), 1)
                        ], 512)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.files, (image, index) => {
                      return (_openBlock(), _createBlock(_component_SortableItem, {
                        index: index,
                        key: index,
                        class: _normalizeClass(["thumb", ['thumb-' + index, { error: image.isError, 'is-empty': image.isPlaceholder }]]),
                        disabled: image.isPlaceholder
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_245, [
                            (image.isSuccess)
                              ? (_openBlock(), _createBlock(_component_ResizableImage, {
                                  key: 0,
                                  url: image.url,
                                  width: 260,
                                  height: 195,
                                  hrmode: "max",
                                  alt: image.file,
                                  draggable: false
                                }, null, 8, ["url", "alt"]))
                              : _createCommentVNode("", true),
                            (!image.isSuccess)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: _ctx.placeholderUrl
                                }, null, 8, _hoisted_246))
                              : _createCommentVNode("", true),
                            (image.isSuccess && index < 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_247, _toDisplayString(index + 1) + ". " + _toDisplayString(_ctx.$t('AdForm.image')), 1))
                              : _createCommentVNode("", true),
                            (image.text)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                                  _createElementVNode("div", null, _toDisplayString(image.file), 1),
                                  _createElementVNode("div", null, _toDisplayString(image.text), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (image.isUploading)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 4,
                                  class: "progress-bar",
                                  style: _normalizeStyle({ width: image.uploadPercentage + '%' })
                                }, null, 4))
                              : _createCommentVNode("", true)
                          ])), [
                            [_directive_handle]
                          ]),
                          (image.isSuccess || image.isError)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.deleteFile(index)),
                                class: "delete-photo"
                              }, null, 8, _hoisted_249))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["index", "class", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["list", "class"])
              ])
            ]),
            _createElementVNode("div", _hoisted_250, [
              _createElementVNode("div", _hoisted_251, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.description.$error }])
                }, [
                  _createElementVNode("label", _hoisted_252, _toDisplayString(_ctx.$t('AdForm.description')) + ":", 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.v$.form.description.$model) = $event)),
                    id: "frm-estateAddForm_description",
                    placeholder: _ctx.$t('AdForm.description-placeholder'),
                    name: "description",
                    class: "form-control is-required"
                  }, null, 8, _hoisted_253), [
                    [
                      _vModelText,
                      _ctx.v$.form.description.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.description.$dirty && _ctx.v$.form.description.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.description.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_254, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              (_ctx.user && _ctx.user.isEstateAgent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.web.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_256, _toDisplayString(_ctx.$t('AdForm.web')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.v$.form.web.$model) = $event)),
                        type: "text",
                        id: "frm-estateAddForm_web",
                        placeholder: _ctx.$t('AdForm.web-placeholder'),
                        name: "web",
                        class: "form-control"
                      }, null, 8, _hoisted_257), [
                        [
                          _vModelText,
                          _ctx.v$.form.web.$model,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_258, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.countryCode.$error }])
                }, [
                  _createElementVNode("label", _hoisted_259, _toDisplayString(_ctx.$t('AdForm.country')) + ":", 1),
                  _createVNode(_component_multiselect, {
                    id: "frm_estateAddForm-country",
                    modelValue: _ctx.country,
                    "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.country) = $event)),
                    "track-by": "key",
                    label: "value",
                    "show-labels": false,
                    options: _ctx.countries,
                    searchable: true,
                    "close-on-select": true,
                    placeholder: _ctx.$t('AdForm.choose-country'),
                    multiple: false,
                    "allow-empty": true
                  }, {
                    noResult: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('multiselect.no-result')), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder"])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_260, [
                _createVNode(_component_MapPosition, {
                  position: _ctx.initialPosition,
                  onAddressChanged: _ctx.onAddressChanged,
                  country: _ctx.country.key,
                  hasError: _ctx.v$.form.address.$error
                }, {
                  default: _withCtx(() => [
                    (_ctx.v$.form.address.$dirty && _ctx.v$.form.address.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.address.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_261, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["position", "onAddressChanged", "country", "hasError"])
              ]),
              (_ctx.user && _ctx.user.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.frontUserId.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_263, _toDisplayString(_ctx.$t('AdForm.estate-agent')) + ":", 1),
                      _createElementVNode("div", _hoisted_264, [
                        _withDirectives(_createElementVNode("select", {
                          id: "frm-estateAddForm_estateAgent",
                          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.v$.form.frontUserId.$model) = $event)),
                          name: "frontUserId",
                          class: "form-control"
                        }, [
                          _hoisted_265,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estateAgents, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.frontUserId,
                              key: item.frontUserId
                            }, _toDisplayString(item.fullName), 9, _hoisted_266))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.v$.form.frontUserId.$model]
                        ])
                      ])
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.isLoggedIn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_267, [
                  _createElementVNode("div", _hoisted_268, [
                    _createElementVNode("div", _hoisted_269, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('AdForm.form-user-header')), 1),
                      (!_ctx.isCompetition)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_270, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.has-account')) + " ", 1),
                            _createVNode(_component_LoginButton, {
                              returnUrl: _ctx.$route.fullPath
                            }, null, 8, ["returnUrl"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_271, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.userName.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_272, _toDisplayString(_ctx.$t('AdForm.userName')) + ":", 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.v$.form.userName.$model) = $event)),
                          type: "text",
                          id: "frm-registerForm_userName",
                          name: "userName",
                          class: "form-control is-required"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.v$.form.userName.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.form.userName.$dirty && _ctx.v$.form.userName.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.userName.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_273, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.phoneNumber.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_274, _toDisplayString(_ctx.$t('AdForm.phoneNumber')) + ":", 1),
                        _createElementVNode("div", _hoisted_275, [
                          _createElementVNode("div", _hoisted_276, [
                            _createVNode(_component_PhonePrefix, {
                              id: "frm-registerForm_phoneNumberPrefix",
                              modelValue: _ctx.v$.form.phoneNumberPrefix.$model,
                              "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.v$.form.phoneNumberPrefix.$model) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.v$.form.phoneNumber.$model) = $event)),
                            type: "text",
                            id: "frm-registerForm_phoneNumber",
                            placeholder: "900 000 000",
                            name: "phoneNumber",
                            class: "form-control"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.v$.form.phoneNumber.$model,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        (_ctx.v$.form.phoneNumber.$dirty && _ctx.v$.form.phoneNumber.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.phoneNumber.phoneNumber.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_277, _toDisplayString(_ctx.$t('forms.phone-number')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_278, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.email.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_279, _toDisplayString(_ctx.$t('AdForm.email')) + ":", 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                          type: "text",
                          id: "frm-registerForm_email",
                          name: "email",
                          class: "form-control is-required"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.v$.form.email.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.email.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_280, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.email.email.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_281, _toDisplayString(_ctx.$t('forms.email')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.confirmEmail.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_282, _toDisplayString(_ctx.$t('AdForm.email')) + ":", 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.v$.form.confirmEmail.$model) = $event)),
                          onPaste: _cache[79] || (_cache[79] = _withModifiers(() => {}, ["prevent"])),
                          type: "text",
                          id: "frm-registerForm_confirmEmail",
                          name: "confirmEmail",
                          class: "form-control is-required"
                        }, null, 544), [
                          [
                            _vModelText,
                            _ctx.v$.form.confirmEmail.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("span", _hoisted_283, _toDisplayString(_ctx.$t('AdForm.email-help-confirm')), 1),
                        (_ctx.v$.form.confirmEmail.$dirty && _ctx.v$.form.confirmEmail.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.confirmEmail.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_284, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.confirmEmail.sameAsEmail.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_285, _toDisplayString(_ctx.$t('AdForm.email-mismatch')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_286, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.password.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_287, _toDisplayString(_ctx.$t('AdForm.password')) + ":", 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.v$.form.password.$model) = $event)),
                          type: "password",
                          id: "frm-registerForm_password",
                          name: "password",
                          class: "form-control is-required"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.v$.form.password.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("span", _hoisted_288, _toDisplayString(_ctx.$t('forms.min', { count: _ctx.v$.form.password.minLength.$params.min })), 1),
                        (_ctx.v$.form.password.$dirty && _ctx.v$.form.password.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.password.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_289, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.password.minLength.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_290, _toDisplayString(_ctx.$t('forms.min', { count: _ctx.v$.form.password.minLength.$params.min })), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.confirmPassword.$error }])
                      }, [
                        _createElementVNode("label", _hoisted_291, _toDisplayString(_ctx.$t('AdForm.password')) + ":", 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.v$.form.confirmPassword.$model) = $event)),
                          type: "password",
                          id: "frm-registerForm_confirmPassword",
                          name: "confirmPassword",
                          class: "form-control is-required"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.v$.form.confirmPassword.$model,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("span", _hoisted_292, _toDisplayString(_ctx.$t('AdForm.password-help-confirm')), 1),
                        (_ctx.v$.form.confirmPassword.$dirty && _ctx.v$.form.confirmPassword.$invalid)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.v$.form.confirmPassword.required.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_293, _toDisplayString(_ctx.$t('forms.required')), 1))
                                : _createCommentVNode("", true),
                              (_ctx.v$.form.confirmPassword.sameAsPassword.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_294, _toDisplayString(_ctx.$t('AdForm.password-mismatch')), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.generalTermsAgreement.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_295, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.$t('AdForm.general-terms', { generalTermsUrl: _ctx.generalTermsUrl, domain: _ctx.domain })
                        }, null, 8, _hoisted_296),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.v$.form.generalTermsAgreement.$model) = $event)),
                          type: "checkbox",
                          id: "frm-registerForm_generalTermsAgreement",
                          name: "generalTermsAgreement"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.v$.form.generalTermsAgreement.$model]
                        ]),
                        _hoisted_297
                      ]),
                      (_ctx.v$.form.generalTermsAgreement.$dirty && _ctx.v$.form.generalTermsAgreement.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.generalTermsAgreement.sameAs.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_298, _toDisplayString(_ctx.$t('forms.required-agreement')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.personalAgreement.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_299, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.$t('AdForm.personal-agreement', { privacyUrl: _ctx.privacyUrl, domain: _ctx.domain })
                        }, null, 8, _hoisted_300),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.v$.form.personalAgreement.$model) = $event)),
                          type: "checkbox",
                          id: "frm-registerForm_personalAgreement",
                          name: "personalAgreement"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.v$.form.personalAgreement.$model]
                        ]),
                        _hoisted_301
                      ]),
                      (_ctx.v$.form.personalAgreement.$dirty && _ctx.v$.form.personalAgreement.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.personalAgreement.sameAs.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_302, _toDisplayString(_ctx.$t('forms.required-agreement')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    (_ctx.isCompetition)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.competitionTermsAgreement.$error }])
                        }, [
                          _createElementVNode("label", _hoisted_303, [
                            _createElementVNode("span", {
                              innerHTML: _ctx.$t('AdForm.competition-terms-agreement', { competitionTermsUrl: _ctx.competitionTermsUrl, domain: _ctx.domain })
                            }, null, 8, _hoisted_304),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.v$.form.competitionTermsAgreement.$model) = $event)),
                              type: "checkbox",
                              id: "frm-registerForm_competitionTermsAgreement",
                              name: "competitionTermsAgreement"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.v$.form.competitionTermsAgreement.$model]
                            ]),
                            _hoisted_305
                          ]),
                          (_ctx.v$.form.competitionTermsAgreement.$dirty && _ctx.v$.form.competitionTermsAgreement.$invalid)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.v$.form.competitionTermsAgreement.sameAs.$invalid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_306, _toDisplayString(_ctx.$t('forms.required-agreement')), 1))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isInsert)
              ? (_openBlock(), _createElementBlock("div", _hoisted_307, [
                  _createElementVNode("div", _hoisted_308, [
                    _createElementVNode("button", _hoisted_309, _toDisplayString(_ctx.$t(_ctx.isCompetition ? 'AdForm.button-insert-competition' : 'AdForm.button-insert')), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 34),
          (_ctx.isEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_310, [
                (_ctx.isShowEstateAgentReviewVisible)
                  ? (_openBlock(), _createBlock(_component_EstateAgentReviewRequestForm, {
                      key: 0,
                      adId: _ctx.form.adId,
                      hasReview: _ctx.form.hasReview
                    }, null, 8, ["adId", "hasReview"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (_ctx.isEdit)
        ? (_openBlock(), _createBlock(_component_FixedElement, {
            key: 1,
            class: _normalizeClass(["notification-panel", _ctx.notificationClass]),
            ref: "bottomNotificationPanel",
            onChange: _ctx.updateFixedStatus,
            threshold: _ctx.$refs.topNotificationPanel && _ctx.$refs.topNotificationPanel.clientHeight,
            bottomThreshold: _ctx.bottomThreshold
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["width-wrap", { 'disabled-all': _ctx.isLoading }])
              }, [
                _createElementVNode("div", _hoisted_311, [
                  _createElementVNode("form", _hoisted_312, [
                    _createElementVNode("div", _hoisted_313, [
                      _createElementVNode("div", _hoisted_314, [
                        _createElementVNode("button", {
                          class: "button button--primary",
                          type: "button",
                          onClick: _cache[86] || (_cache[86] = ($event: any) => (_ctx.save(true)))
                        }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-save-short' : 'AdForm.button-save')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_315, [
                        _createElementVNode("button", {
                          class: "button button--primary reversed",
                          type: "button",
                          onClick: _cache[87] || (_cache[87] = 
//@ts-ignore
(...args) => (_ctx.onShowPreview && _ctx.onShowPreview(...args)))
                        }, _toDisplayString(_ctx.$t(_ctx.isMobile ? 'AdForm.button-preview-short' : 'AdForm.button-preview')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_316, [
                        (_ctx.isMobile)
                          ? (_openBlock(), _createBlock(_component_multiselect, {
                              key: 0,
                              class: "multiselect-statuses w200",
                              modelValue: _ctx.publishStatus,
                              "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.publishStatus) = $event)),
                              options: _ctx.publishStatuses,
                              "show-labels": false,
                              searchable: false,
                              "allow-empty": false
                            }, {
                              singleLabel: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('AdForm.status-change')), 1)
                              ]),
                              option: _withCtx(({ option }) => [
                                (option === 'publish')
                                  ? (_openBlock(), _createElementBlock("label", _hoisted_317, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.isPublished) = $event)),
                                        onChange: _cache[89] || (_cache[89] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                        disabled: !_ctx.form.isEmailConfirmed || _ctx.form.isArchived
                                      }, null, 40, _hoisted_318), [
                                        [_vModelCheckbox, _ctx.isPublished]
                                      ]),
                                      _hoisted_319,
                                      _createElementVNode("span", _hoisted_320, [
                                        (_ctx.form.isPublished)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.published')), 1)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(_ctx.$t('AdForm.unpublished')), 1)
                                            ], 64))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (option === 'reserve' && !_ctx.isDeveloperProjectEstate)
                                  ? (_openBlock(), _createElementBlock("label", _hoisted_321, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.reserved')), 1),
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: _ctx.form.isReserved,
                                        onChange: _cache[90] || (_cache[90] = 
//@ts-ignore
(...args) => (_ctx.onReservedChanged && _ctx.onReservedChanged(...args)))
                                      }, null, 40, _hoisted_322),
                                      _hoisted_323
                                    ]))
                                  : _createCommentVNode("", true),
                                (option === 'archive')
                                  ? (_openBlock(), _createElementBlock("label", _hoisted_324, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.archived')), 1),
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: _ctx.form.isArchived,
                                        onChange: _cache[91] || (_cache[91] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                      }, null, 40, _hoisted_325),
                                      _hoisted_326
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "options"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (!_ctx.isDeveloperProjectEstate)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_327, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.reserved')), 1),
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: _ctx.form.isReserved,
                                      onChange: _cache[93] || (_cache[93] = 
//@ts-ignore
(...args) => (_ctx.onReservedChanged && _ctx.onReservedChanged(...args)))
                                    }, null, 40, _hoisted_328),
                                    _hoisted_329
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("label", _hoisted_330, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdForm.archived')), 1),
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: _ctx.form.isArchived,
                                  onChange: _cache[94] || (_cache[94] = 
//@ts-ignore
(...args) => (_ctx.onArchivedChanged && _ctx.onArchivedChanged(...args)))
                                }, null, 40, _hoisted_331),
                                _hoisted_332
                              ]),
                              _createElementVNode("label", _hoisted_333, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.isPublished) = $event)),
                                  onChange: _cache[96] || (_cache[96] = 
//@ts-ignore
(...args) => (_ctx.onPublishChanged && _ctx.onPublishChanged(...args))),
                                  disabled: !_ctx.form.isEmailConfirmed
                                }, null, 40, _hoisted_334), [
                                  [_vModelCheckbox, _ctx.isPublished]
                                ]),
                                _hoisted_335,
                                _createElementVNode("span", _hoisted_336, [
                                  (_ctx.form.isPublished)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('AdForm.published')), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('AdForm.unpublished')), 1)
                                      ], 64))
                                ])
                              ])
                            ], 64))
                      ])
                    ])
                  ])
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["class", "onChange", "threshold", "bottomThreshold"]))
        : _createCommentVNode("", true),
      (_ctx.$refs.bottomNotificationPanel && _ctx.isHeaderFixed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            style: _normalizeStyle({ height: _ctx.$refs.bottomNotificationPanel.$el.clientHeight + 'px' })
          }, null, 4))
        : _createCommentVNode("", true),
      (_ctx.showPreview)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 3,
            to: "#container"
          }, [
            _createVNode(_component_AdPreview, {
              adFrontId: _ctx.form.adFrontId,
              onClose: _cache[97] || (_cache[97] = ($event: any) => (_ctx.showPreview = false))
            }, null, 8, ["adFrontId"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}